import React, { useMemo } from 'react';
import blockies from 'blockies-ts';

import { useChain } from 'contexts';
import { formatAccount } from 'utils/chain';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  account: string;
};

const AccountButton: React.FC<Props> = ({ account, ...buttonProps }) => {
  const { styleSlug } = useChain();
  const avatarSrc = useMemo(() => blockies.create({ seed: account }).toDataURL(), [account]);
  return (
    <div
      className={`rounded-full bg-${styleSlug}-light bg-gradient-to-l dark:from-${styleSlug}-light dark:to-${styleSlug}-primary`}
      style={{ padding: 2, height: 42 }}
    >
      <button
        className={`h-full pl-4 pr-1 py-1 rounded-full bg-white dark:bg-gray-111 text-sm text-${styleSlug}-primary dark:text-${styleSlug}-light`}
        {...buttonProps}
      >
        <span className="align-middle">{formatAccount(account)}</span>
        <img src={avatarSrc} alt="" className="ml-2 rounded-full inline align-middle" />
      </button>
    </div>
  );
};

export default AccountButton;
